import { Language } from '@square/dashboard-protos/models/squareup/common/languages';
export function getLanguageEnumFromLocale(locale) {
  switch (locale) {
    case 'es-us':
    case 'es':
      return Language.ES;
    case 'en-us':
    case 'en':
    default:
      return Language.EN;
  }
}